const functionsRegion = 'northamerica-northeast1';
const projectId = 'spaq-mobile-development';

export const environment = {
	id: 'base',
	general: {
		adminEmail: 'NEPASREPONDRE@spaq.com',
		techEmail: 'NEPASREPONDRE@spaq.com',
		siteDescription: '',
		siteName: '',
		userCanRegister: true,
		siteUrl: 'https://spaq-mobile-development.firebaseapp.com'
	},
	production: false,
	showInternal: true,
	services: {
		vehicles: true,
		metadata: true,
		sectors: true,
		services: true,
		accountStatus: true,
		user: true,
		faq: true,
		profile: true,
		subscription: true,
		parks: true,
		organization: true,
		contract: true,
		accessCode: true
	},
	recaptcha: {
		siteKey: '6Lcqg9QiAAAAAIXPvqEsZNv8hSPrAKEeFrGbfymw'
	},
	functionsRegion,
	firebase: {
		apiKey: 'AIzaSyAlXGJVQx1iAgWiJq7eY2U7hrsrHCM_sEw',
		authDomain: 'spaq-mobile-development.firebaseapp.com',
		databaseURL: 'https://spaq-mobile-development.firebaseio.com',
		projectId,
		storageBucket: 'spaq-mobile-development.appspot.com',
		messagingSenderId: '416287612067',
		appId: '1:416287612067:web:88c6a8d36a833d63e0f316',
		measurementId: 'G-E2C8EZXSTF'
	},
	backendApiUrl: `https://${functionsRegion}-${projectId}.cloudfunctions.net`,
	moneris: {
		url: 'https://esqa.moneris.com/HPPtoken/index.php',
		paypage: {
			id: 'M4GQ3tore1',
			key: 'hpXEANG66AJ6'
		},
		vault: {
			id: 'ENU7Ttore1',
			key: 'res4LS4NFBYC'
		}
	},
	settings: {
		menu: [
			{
				id: 'subscription',
				name: 'Informations personnelles',
				description: 'Configurez vos informations personnelles qui seront utilisées par défaut dans votre compte.'
			},
			{ id: 'profile', name: 'Profil du compte', description: 'Configurez vos informations de connexion' },
			{ id: 'vehicles', name: 'Mes véhicules', description: 'Configurez vos véhicules' },
			{ id: 'password', name: 'Mot de passe', description: 'Modifiez le mot de passe de votre compte' },
			{ id: 'email', name: 'Adresse courriel', description: "Modifiez l'adresse courriel de votre compte" },
			{ id: '2fa', name: 'Validation en deux étapes ', description: 'Validation en deux étapes' }
		]
	},
	scopes: {
		cnmtl: {
			selectSectorText: "Selectionnez l'installation désirée"
		},
		cisssbsl: {
			hideAddressInParkList: true
		},
		artm: {
			hideAddressInParkList: true
		},
		cisssca: {
			hideAddressInParkList: true
		},
		cisssgaspesie: {
			hideAddressInParkList: true,
			selectServiceTitle: "Sélectionnez le port d'attache",
			accessCardText: `Le stationnement sélectionné pourrait nécessiter une carte d'accès pour y accéder`
		},
		cssdm: {
			allowRegistrationDomains: ['spaq.com', 'csdm.qc.ca'],
			showSubmitCardHolder: true,
			acceptPaymentOnApproveText:
				"Je comprends que je pourrai accéder au stationnement seulement lorsque ma demande aura été approuvée, et que je ne serai facturé qu'après avoir utilisé le service.",
			accessCardText: `Le stationnement sélectionné pourrait nécessiter une carte d'accès pour y accéder`
		},
		ramq: {
			denyRegistrationDomains: ['ramq.gouv.qc.ca']
		},
		public: {
			acceptPaymentOnApproveText:
				"Je comprends que je pourrai accéder au stationnement seulement lorsque ma demande aura été approuvée, et que je ne serai facturé qu'après avoir utilisé le service.",
			accessCardText: `Le stationnement sélectionné nécessite une carte d'accès pour y accéder`,
			hideTextNotApplicableLicensePlate: true
		},
		ccsmtl: {
			disableImportOnContractCreate: true,
			accessCardText: `Le stationnement sélectionné pourrait nécessiter une carte d'accès pour y accéder`
		}
	},
	useEmulators: false
};
